import { apiClient } from "@/services/api";

export default {
  getUserInfo(id) {
    return apiClient.get("/users/" + id);
  },
  getAuthed() {
    return apiClient.get("/users/authed");
  },
  renewPasses(data) {
    return apiClient.post("/users/passes", data);
  },
  async getSetupIntent() {
    return apiClient.get("/users/setup-intent");
  },
  update(userId, data) {
    return apiClient.put("/users/" + userId, data);
  },
  updateRole(userId, data) {
    return apiClient.post("/users/" + userId + "/role", data);
  }
};
